export default __webpack_public_path__ + "static/media/handshake.4fffc010.svg";